import script from "./UserQuestionDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserQuestionDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserQuestionDetailModal.vue?vue&type=style&index=0&id=4e92e47e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e92e47e"]])

export default __exports__